import { Link } from 'react-router-dom';
import SectionHeader from '@/components/base/SectionHeader';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="bg-accent-950 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-accent-300">
            <span className="h-px w-6 bg-accent-500"></span>
            主题分类
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            按领域挑你想追的那一类
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-200/80">
            娱乐圈、网红、商战、科技、综艺影视，各自有各自的时间线与节奏，挑一类进去慢慢追。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/dramas?cat=${cat.id}`}
              className="group flex flex-col rounded-lg border border-accent-800/70 bg-accent-900/50 p-5 transition-colors duration-200 hover:border-accent-600 hover:bg-accent-900"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-800 text-accent-200 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-sm text-accent-300">{cat.count} 出</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-background-50">
                {cat.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-background-200/75">
                {cat.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-accent-300 group-hover:text-accent-200">
                进入分类
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}